<template>
  <div v-if="security" class="company-info">
    <div class="status-company liner">
      <strong>Черные списки: </strong>
      <div class="status-content" 
        v-if="security.black_list || security.black_list_client ">В черном списке
      </div>
      <div class="status-content" v-else>В ЧС не значится</div>
    </div>

    <div class="security-data">
      <div class="security-base-information">
        <h3>ИНН</h3>
        <div v-if="security.nalog_is_end">
          <p>
            <strong>ИНН: </strong>
            {{ security.nalog_inn_number }}
          </p>
          <p>
            <strong>Статус: </strong>
            {{ security.nalog_inn_status }}
          </p>
        </div>
        <div v-else><p>Еще не проверен</p></div>
      </div>
    
      <div class="security-base-information passport">
        <h3>Паспорт</h3>
        <div v-if="security.dadata_is_end">
          <p>
            <strong>Номер: </strong>
            {{ security.dadata_passport_number }}
          </p>
          <p>
            <strong>Cтатус: </strong>
            {{ security.dadata_passport_status }}
          </p>
        </div>
        <div v-else><p>Еще не проверен</p></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DriverSecurityInfo',
  props: ['security'],
};
</script>

<style scoped>
.company-info{
  display: flex;
  flex-direction: column;
}

.security-data{
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.security-base-information {
  
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.company-info h3 {
  font-size: 20px;
  font-weight: bold;
}

.company-info p {
  margin: 5px 0;
}

.company-info p:first-child {
  margin-top: 0;
}

.status-company{
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.status-content{
  margin-left: 10px;
  margin-bottom: 4px;
}

.security-base-information{
  display: flex;
  flex-direction: column;
  text-align: left;
  flex-grow:1
}

.passport{
  align-self: flex-start;
}
</style>
